function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4A4757",
  d: "M14.706 1v2.178h-2.229v2.215H6.61L18 24.996 29.392 5.393h-8.09V3.215h2.21V1H32.2C33.746 1 35 2.246 35 3.782c0 .489-.13.968-.375 1.391l-14.2 24.435a2.81 2.81 0 0 1-4.85 0L1.375 5.173a2.772 2.772 0 0 1 1.026-3.8A2.814 2.814 0 0 1 3.8 1h10.905z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00BBE6",
  d: "M18.004 16.229a1.56 1.56 0 0 1 1.566 1.555c0 .422-.168.804-.442 1.084v.033h-.033c-.282.272-.667.44-1.09.44a1.56 1.56 0 0 1-1.567-1.557 1.56 1.56 0 0 1 1.566-1.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C263BF",
  d: "M19.128 7.626v2.196h-2.211V7.626z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8BA2",
  d: "M16.917 5.429v2.197h-2.211V5.429z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4757",
  fillOpacity: 0.2,
  d: "M23.512 1v2.215h-2.211V1zm-8.806 2.178v2.215h-2.233V3.178z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4757",
  d: "M44.52 8.983c2.972 0 5.477 1.033 7.48 3.086 2 2.05 3.036 4.845 3.11 8.361l.01.456-.15.152H38.224c.202 1.729.84 3.123 1.917 4.2 1.2 1.2 2.613 1.793 4.272 1.793 2.867 0 5.03-1.426 6.558-4.337l.202-.063 3.274 1.715.062.2c-1.156 2.181-2.532 3.8-4.131 4.857C48.766 30.468 46.844 31 44.626 31c-3.071 0-5.628-1.085-7.632-3.24C35 25.614 34 23.022 34 20.01s1.007-5.612 3.012-7.768c2.015-2.167 4.53-3.259 7.508-3.259zM80.355 5l7.806 14.032h.567L96.534 5h4.39v26h-4.287V18.185l.302-4.698h-.688l-6.487 11.885H87.16l-6.523-11.885h-.688l.302 4.715V31H76V5h4.355zm42.074 0v4.23h-10.99v6.655h9.887v4.23h-9.886v6.656h10.989V31h-15.15V5h15.15zm-58.47 3.983l.145.15v1.388a6.24 6.24 0 0 1 .933-.799 4.201 4.201 0 0 1 2.432-.739c.885 0 1.862.283 2.936.845l.429.225.056.212-2.037 3.232-.187.052-.35-.18c-.332-.171-.643-.255-.938-.255-.575 0-1.098.282-1.596.874-.547.65-.962 1.516-1.243 2.6-.287 1.11-.435 3.186-.435 6.174v7.768l-.145.148h-3.924l-.145-.148V9.132l.145-.149h3.924zM44.481 13.15c-2.9 0-4.87 1.22-5.999 3.716l-.022.052h12.263c-.399-1.066-1.079-1.915-2.05-2.562-1.211-.805-2.604-1.206-4.192-1.206z"
}));

var SvgLogoVermeDark = function SvgLogoVermeDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 32,
    viewBox: "0 0 123 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoVermeDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_verme_dark.79d1617c.svg";
export { ForwardRef as ReactComponent };